import moment from "moment";
import { minValidDate } from "../../DataEntry/Grid/gridFunctions";
import { parseRegisterFieldInfo } from "../utils";
import { validateOverallPageFrom, validateOverallPageTo } from "./validationSchema835Lte";

const validateHeader = (values,field, context) => {
  const errors = {};
  const { isSubJob, isFirstJob, isAdditional, isAdditionalInfoOptions, totalPages, isPayerPage, isDbkPermission } = context;

  

  
    switch (field) {
        case "overall_page_from":
            const result = validateOverallPageFrom(values.overall_page_from, values, context);
            if (result) {
                errors.overall_page_from = result
            };
        break;
        case "overall_page_to":
            const result1 = validateOverallPageTo(values.overall_page_to, values, context);
            if (result1) {
                errors.overall_page_to = result1
            };
        break;
      
      case "payer_name":
        if (values?.qdx_status !== "INCOMPLETE" && !(isSubJob && !isFirstJob) && !values.payer_name) {
          errors.payer_name = "Required";
        }
        break;

      case "letter_date":
        if (values?.qdx_status !== "INCOMPLETE" && !(isSubJob && !isFirstJob) && !values.letter_date) {
          errors.letter_date = "Required";
        }
        if (values.letter_date?.replace("__/__/____", "") !== "" &&
            (!moment(values.letter_date, "MM/DD/YYYY", true).isValid() ||
             !moment(values.letter_date, "MM/DD/YYYY", true).isAfter(minValidDate))) {
          errors.letter_date = "Invalid date";
        }
        break;

      case "correspondance":
        if (values?.qdx_status !== "INCOMPLETE" && !(isSubJob && !isFirstJob) &&
            (!values.correspondance || values.correspondance === "0")) {
          errors.correspondance = "select an option";
        }
        break;

      case "qdx_status":
        if (isAdditional && isAdditionalInfoOptions?.status && values.qdx_status === "") {
          errors.qdx_status = "Required";
        }
        break;

      case "qdx_reason":
        if (isAdditional &&
            isAdditionalInfoOptions?.status &&
            isAdditionalInfoOptions?.reason &&
            values.qdx_status === "INCOMPLETE" &&
            !values.qdx_reason) {
          errors.qdx_reason = "Required";
        }
        break;

      case "payer_page_from":
      case "payer_page_to":
        if (totalPages > 0 && isPayerPage) {
          if (
            values?.payer_page_from <= 0 ||
            values?.payer_page_from === "" ||
            values?.payer_page_from > totalPages ||
            values?.payer_page_from > values?.payer_page_to
          ) {
            errors.payer_page_from = "Invalid Page Number";
            errors.payer_page_to = "Invalid Page Number";
          }
          if (
            values?.payer_page_to <= 0 ||
            values?.payer_page_to === "" ||
            values?.payer_page_to > totalPages ||
            values?.payer_page_from > values?.payer_page_to
          ) {
            errors.payer_page_from = "Invalid Page Number";
            errors.payer_page_to = "Invalid Page Number";
          }
        }
        break;
    default:
    }


  return errors;
};



export const validateCorresClaim = (claim, field, context, values) => {
  const errors = {};
  const {  totalPages, isDbkPermission } = context;
  if(values?.qdx_status === "INCOMPLETE") return
  switch (field) {
    case "period_start":
      if (!claim.period_start || claim.period_start.replace("__/__/____", "") === "") {
        errors.period_start = "Required";
      } else if (
        !moment(claim.period_start, "MM/DD/YYYY", true).isValid() ||
        !moment(claim.period_start, "MM/DD/YYYY", true).isAfter(minValidDate)
      ) {
        errors.period_start = "Invalid date";
      }
      break;

    case "period_end":
      if (!claim.period_end || claim.period_end.replace("__/__/____", "") === "") {
        errors.period_end = "Required";
      } else if (
        !moment(claim.period_end, "MM/DD/YYYY", true).isValid() ||
        !moment(claim.period_end, "MM/DD/YYYY", true).isAfter(minValidDate)
      ) {
        errors.period_end = "Invalid date";
      }
      break;

    case "page_from":
    case "page_to":
      if (totalPages > 0) {
        if (
          Number(claim.page_from) > totalPages ||
          Number(claim.page_from) > Number(claim.page_to) ||
          !claim.page_from ||
          claim.page_from <= 0
        ) {
          errors.page_from = "Invalid page";
          errors.page_to = "Invalid page";
        }
        if (
          Number(claim.page_to) > totalPages ||
          Number(claim.page_from) > Number(claim.page_to) ||
          !claim.page_to
        ) {
          errors.page_from = "Invalid page";
          errors.page_to = "Invalid page";
        }
      }
      break;

    case "patient_account_number":
      if (!claim.patient_account_number) {
        errors.patient_account_number = "Required";
      }
      break;

    default:
      break;
  }

  return errors;
};






export const validateAllFieldsCorres = (values, context) => {
  let errors = {};

  // Top-level fields
    
  ["overall_page_from","overall_page_to","payer_name", "letter_date", "correspondance", "qdx_status", "qdx_reason", "payer_page_from", "payer_page_to"].forEach(
    (field) => {
      const fieldErrors = validateHeader(values, field, context);
      if (fieldErrors && Object.keys(fieldErrors).length > 0) {
        errors = { ...errors, ...fieldErrors };
      }
    }
  );

  // Claims
  if (values.claims && Array.isArray(values.claims)) {
    errors.claims = values.claims.map((claim) => {
      let claimErrorObj = {};

      // Claim-level fields
      [
    "period_start",
    "period_end",
    "page_from",
    "page_to",
    "patient_account_number",
    "patient_first_name",
    "patient_middle_name",
    "patient_last_name",
    "billed"].forEach((field) => {
        const claimFieldErrors = validateCorresClaim(claim, field, context,values);
        if (claimFieldErrors) {
          claimErrorObj = { ...claimErrorObj, ...claimFieldErrors };
        }
      });
    
      return { ...claimErrorObj,  };
    });
  }

  // Remove empty error objects
  const cleanErrors = JSON.parse(
    JSON.stringify(errors, (key, value) =>
      value && typeof value === "object" && Object.keys(value).length === 0
        ? undefined
        : value
    )
  );

  return Object.keys(cleanErrors).length > 0 ? cleanErrors : null;
}




export const validateSingleFieldCorres = (fieldPaths, values,setError, clearErrors, context) => {
  
  
  if (!Array.isArray(fieldPaths) || fieldPaths.length === 0) return;

  // Clear old errors first
 
  fieldPaths.forEach((fieldPath) => {
    let errorMessage = null;

    // Top-level fields
    if (["overall_page_from","overall_page_to","check_number", "check_amount", "check_date", "aba_routing_number" ,'payer_name',"letter_date","correspondance","payer_page_to","payer_page_from"].includes(fieldPath)) {
      const errors = validateHeader(values, fieldPath, context);
      errorMessage = errors[fieldPath] || null;
    }

    // Claim-level fields
    const {claimIndex,fieldName:claimField} = parseRegisterFieldInfo(fieldPath)
    if (claimIndex !== undefined && claimIndex !== null) {
      const claimErrors = validateCorresClaim(values.claims[claimIndex], claimField, context,values);
      errorMessage = claimErrors ? claimErrors[claimField] || null : null;
    }

    // Set error into RHF if exists
    if (errorMessage) {
      setError(fieldPath, { type: "custom", message: errorMessage });
    }else{
       clearErrors(fieldPath);

    }

  });
};